import type { NewsItem } from "@/types/content";

export const news: NewsItem[] = [
  {
    id: "news-1",
    title: "《我妻子的一切》收视率再创新高，大结局前夜引发全网热议",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20dim%20living%20room%20with%20a%20glowing%20television%20screen%20casting%20soft%20navy%20light%2C%20muted%20warm%20grey%20surroundings%2C%20popcorn%20and%20remote%20on%20table%2C%20cozy%20night%20mood%2C%20high%20detail%2C%20professional%20composition&width=1200&height=750&seq=iwm-news-01&orientation=landscape",
    summary:
      "随着大结局临近，剧集收视率连续三周攀升。社交平台上关于结局走向的讨论量突破百万，多个话题登上热搜榜。",
    content: [
      "据最新数据显示，《我妻子的一切》第十五集全国收视率再度刷新自身纪录，成为近期表现最亮眼的剧集之一。",
      "网络讨论热度同样居高不下：观众自发整理的时间线、角色关系图在社交平台被大量转发，关于「素妍会选择和解还是放手」的投票参与人数超过五十万。",
      "平台方表示，大结局将采用加长版播出，并会在片尾放出幕后花絮，回馈一路追剧的观众。",
      "业内评论认为，该剧的成功证明了「慢节奏、重细节」的家庭题材依然拥有庞大的观众基础。",
    ],
    tags: ["收视", "热议"],
    date: "2023-11-25",
    author: "资讯组 · 周然",
    source: "本站资讯组",
    hot: 9860,
  },
  {
    id: "news-2",
    title: "主演阵容幕后花絮曝光：一场长镜头拍了整整两天",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20behind%20the%20scenes%20photo%20of%20a%20film%20set%20with%20professional%20camera%20rig%20and%20softboxes%2C%20muted%20navy%20and%20warm%20grey%20tones%2C%20rain%20machine%20mist%2C%20atmospheric%20industrial%20studio%2C%20high%20detail%2C%20professional%20composition&width=1200&height=750&seq=iwm-news-02&orientation=landscape",
    summary:
      "剧组公开了一段幕后纪录短片，还原了第七集那场著名的雨中长镜头。为了等一场合适的雨，全体演员在片场等待了超过三十小时。",
    content: [
      "这场全长两分钟的雨夜长镜头，全剧仅用一镜到底完成，没有剪辑点，对演员的情绪控制和走位要求极高。",
      "导演在花絮中透露，为了等到符合光线条件的雨量，剧组连续两天空等，最终在第三天凌晨四点半才拍到满意的一条。",
      "女主角在采访中表示，拍完这条镜头后她在监视器前坐了很久，「因为我知道角色的某一部分已经结束了」。",
      "幕后短片上线后不到二十四小时播放量即突破两百万，不少观众表示「看完花絮，正式片段又哭了一遍」。",
    ],
    tags: ["幕后", "花絮"],
    date: "2023-11-20",
    author: "资讯组 · 周然",
    source: "本站资讯组",
    hot: 8420,
  },
  {
    id: "news-3",
    title: "编剧专访：这个故事最早来自一碗放凉的粥",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20writing%20desk%20with%20an%20open%20notebook%20pencil%20and%20a%20bowl%20of%20cooled%20porridge%2C%20muted%20navy%20and%20ivory%20tones%2C%20soft%20morning%20window%20light%2C%20quiet%20reflective%20mood%2C%20high%20detail%2C%20professional%20composition&width=1200&height=750&seq=iwm-news-03&orientation=landscape",
    summary:
      "在接受本站专访时，编剧首次讲述了创作缘起：一次偶然的早餐，她看见一对夫妻各自沉默地吃着饭，那个画面成了整部剧的种子。",
    content: [
      "「我那天在他们对面坐了四十分钟，他们一句话都没说，但每个人都在偷偷看对方一眼。」编剧回忆道，这个细节让她意识到，沉默其实是一种极其丰富的表达。",
      "谈到角色的塑造，她表示素妍这个角色并不是单一的受害者，而是一个主动选择、也主动回避的复杂个体，「我想写的不是谁对谁错，而是两个人怎么就走到了这里」。",
      "对于结局的处理，编剧坦言曾写过三个版本，最终选择了最克制的那一版，「因为生活本来就不会给你一个响亮的句号」。",
      "她也透露，剧中反复出现的舞台元素并非偶然，那是留给素妍、也留给观众的一个出口。",
    ],
    tags: ["专访", "创作"],
    date: "2023-11-18",
    author: "编辑部 · 顾清和",
    source: "本站编辑部",
    hot: 6120,
  },
  {
    id: "news-4",
    title: "制作方确认将推出导演剪辑版，新增约四十分钟内容",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20film%20editing%20suite%20with%20color%20grading%20monitors%20showing%20muted%20navy%20frames%2C%20dim%20warm%20grey%20room%2C%20technical%20calm%20mood%2C%20high%20detail%2C%20professional%20composition&width=1200&height=750&seq=iwm-news-04&orientation=landscape",
    summary:
      "制作方在官方渠道宣布，将在流媒体平台上线导演剪辑版，补充大量在播出时被剪掉的支线与角色细节。",
    content: [
      "据制作方介绍，导演剪辑版将在原剧十六集的基础上，增加约四十分钟的内容，主要集中在老宅支线与配角群像上。",
      "其中包含被删减的崔恩珠婚姻往事片段，以及朴志焕与素妍大学时期的两场戏。",
      "制作方表示，这些内容播出时因为时长原因被割舍，但它们是理解角色动机的重要拼图。",
      "导演剪辑版预计将在原剧完结后一个月上线，具体日期以官方公告为准。",
    ],
    tags: ["官方", "剪辑版"],
    date: "2023-11-15",
    author: "资讯组 · 周然",
    source: "本站资讯组",
    hot: 5230,
  },
  {
    id: "news-5",
    title: "剧中取景地成热门打卡点，老街咖啡馆排队超一小时",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20photo%20of%20a%20quiet%20old%20neighborhood%20street%20with%20a%20small%20coffee%20shop%20and%20hanging%20signs%2C%20muted%20navy%20and%20sepia%20tones%2C%20soft%20afternoon%20light%2C%20nostalgic%20warm%20atmosphere%2C%20high%20detail%2C%20professional%20composition&width=1200&height=750&seq=iwm-news-05&orientation=landscape",
    summary:
      "随着剧集走红，多处取景地成为观众打卡目的地。剧中崔恩珠的咖啡馆原型店，周末排队时间一度超过一小时。",
    content: [
      "老街区因戏而热闹起来，不少观众专程前来寻找剧中出现的转角、石阶与那家小咖啡馆。",
      "咖啡馆店主表示，最近客流是平常的三倍，「很多人进来只想坐一坐，点一杯和剧里一样的茶」。",
      "当地文旅部门也顺势推出了「剧集取景地图」，串联起老街、剧场与老宅原型等地点。",
      "有观众表示，实地走一遍之后，再看剧中的那些镜头，感受完全不同了。",
    ],
    tags: ["取景地", "打卡"],
    date: "2023-11-12",
    author: "资讯组 · 何映",
    source: "本站资讯组",
    hot: 4880,
  },
  {
    id: "news-6",
    title: "演技分析：韩智秀如何用一个眼神演完十二年的婚姻",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20editorial%20close%20up%20photo%20of%20an%20east%20asian%20woman%20face%20in%20soft%20profile%2C%20muted%20navy%20and%20ivory%20tones%2C%20subtle%20dramatic%20side%20lighting%2C%20restrained%20emotional%20expression%2C%20film%20still%20style%2C%20high%20detail%2C%20professional%20composition&width=1200&height=750&seq=iwm-news-06&orientation=landscape",
    summary:
      "剧中女主角几乎没有大段台词的情绪爆发戏，所有力量都压在眼神与呼吸上。这种「收着演」的处理方式，正是全剧质感的来源。",
    content: [
      "在第九集那场整理旧物的戏里，素妍从翻开盒子到落泪，前后不过十几秒，却完成了从好奇、回忆到崩溃的完整情绪弧线。",
      "表演的关键在于节奏：她先停顿、再呼吸、最后才是眼睛的变化。观众不是被台词打动，而是被那个「忍住不哭」的瞬间击中。",
      "对比闪回线中年轻素妍的明亮外放，两个年龄段的表演形成了鲜明反差，也让角色的变化有了可触摸的重量。",
      "有评论写道：「她没有演婚姻的崩溃，她演的是崩溃之前那段漫长的克制。」",
    ],
    tags: ["演技", "分析"],
    date: "2023-11-08",
    author: "编辑部 · 沈砚",
    source: "本站编辑部",
    hot: 5660,
  },
];